import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { SiteCatalog } from '../models/siteCatalog';

export function getCatalogs(): Promise<SiteCatalog[]> {
  return cacheableRequest('/catalogs').then(({ data }: AxiosResponse<SiteCatalog[]>) => data);
}
